<template>
  <div class="carousel-slide">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'homepageslide',
};
</script>
